import type { ComponentProps } from "react"
import { MultiEditSkuPanel } from "~/components/planning/MultiEditSkuPanel"
import { NoosVariantOverflow } from "./NoosVariantOverflow"

type Props = Omit<ComponentProps<typeof MultiEditSkuPanel>, "renderOverflow">

/** The variant command bar on NOOS tabs: Edit and Tags sit in the overflow menu. */
export function NoosVariantCommandBar(props: Props) {
  return (
    <MultiEditSkuPanel
      {...props}
      renderOverflow={(variants) => (
        <NoosVariantOverflow
          selectedVariantIds={props.selectedVariantIds}
          variants={variants}
          onApplied={props.clearSelectedVariantIds}
        />
      )}
    />
  )
}
